<div class="logo"></div>

<div *ngIf="errorMessage && errorMessage.length>0" class="error mat-error">
  {{errorMessage}}
</div>

<mat-card *ngIf="segment">
  <p class="mat-title">Active Status</p>
  <mat-card-content>
    <mat-slide-toggle (ngModelChange)="updateStatus($event)" [(ngModel)]="segment.active" [checked]="segment?.active"
                      [disabled]="updatingStatus"
                      color="accent" matTooltip="Click to change the status immediately to XANDR"
                      name="status">
    </mat-slide-toggle>
  </mat-card-content>
  <div *ngIf="updatingStatus" disabled="">Requesting...</div>
</mat-card>


<app-xandr-price class="xandr-billings"
                 *ngIf="account?.apiId"
                 #price
                 [billing]="billing"
                 [account]="account"
                 (priceModified)="onPriceModified($event)">
</app-xandr-price>

<div *ngIf="showLoading()" class="xandr-billings">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>

<div class="flex-container">
  <app-xandr-buyers *ngIf="showBuyers()"
                    [account]="account" [billing]="billing" [buyersName]="'Buyer'"
                    class="xandr-billings xandr-buyers"
                    id="xander-buyer-name"></app-xandr-buyers>

  <app-xandr-buyers
    *ngIf="account?.foreignIdForCurrentSegment || (xandrService.isDryMode && account?.apiId)"
    [account]="account" [buyersName]="'Publisher'" class="xandr-billings xandr-publishers"
    id="xander-publisher-name"></app-xandr-buyers>
</div>
